// Comptes Courants d'Associés — le grand livre CCA vit côté serveur ; la
// contrepartie de trésorerie est écrite par le serveur dans `oliva.finances`
// (aucune trésorerie parallèle côté frontend).
const API = `${process.env.REACT_APP_BACKEND_URL}/api/cca`;

export const CATEGORIE_CCA = "Financement — Comptes courants d'associés";

const entetes = (u) => ({
  'Content-Type': 'application/json',
  'X-Utilisateur': encodeURIComponent(u?.name ?? u?.nom ?? 'inconnu'),
  'X-Utilisateur-Role': u?.role ?? '',
  'X-Utilisateur-Email': u?.email ?? '',
});

const json = async (r) => {
  const data = await r.json().catch(() => null);
  if (!r.ok) return { error: data?.detail ?? `Erreur ${r.status}`, data: null };
  return { error: null, data };
};

const get = async (url, u) => json(await fetch(url, { headers: entetes(u) }));
const post = async (url, corps, u) =>
  json(await fetch(url, { method: 'POST', headers: entetes(u), body: JSON.stringify(corps ?? {}) }));

export const ROLES_SAISIE_CCA = ['Administrateur', 'Comptable'];
export const peutSaisirCca = (u) => ROLES_SAISIE_CCA.includes(u?.role);
export const peutRepriseCca = (u) => u?.role === 'Administrateur';

export const fetchEtatCca = async (u) => (await get(`${API}/etat`, u)).data;
export const fetchReleveCca = async (contactId, u) => (await get(`${API}/releve/${contactId}`, u)).data;
export const fetchReprisesCca = async (u) => (await get(`${API}/reprises`, u)).data ?? [];
export const fetchAccesCca = async (u) => (await get(`${API}/acces`, u)).data ?? { emails: [] };

export const initialiserAssocies = (u) => post(`${API}/associes/initialiser`, {}, u);
export const rattacherAssocie = (contactId, u) => post(`${API}/associes/rattacher`, { contact_id: contactId }, u);

export const enregistrerMouvementCca = (payload, u) => post(`${API}/mouvement`, payload, u);
export const validerMouvementCca = (id, u, lien = null) =>
  post(`${API}/mouvement/${id}/valider`, { tresorerie_existante: lien }, u);

// Écritures de trésorerie déjà saisies, non affectées, utilisables comme contrepartie
// d'un mouvement CCA (même compte, montant exact, sens attendu).
export const fetchCandidatsTresorerieCca = async ({ nature, compte_id, montant }, u) => {
  const q = new URLSearchParams({ nature, compte_id, montant: String(montant) });
  return (await get(`${API}/tresorerie/candidats?${q}`, u)).data?.candidats ?? [];
};
export const contrepasserMouvementCca = (id, motif, u) => post(`${API}/mouvement/${id}/contrepasser`, { motif }, u);
export const supprimerBrouillonCca = async (id, u) => json(await fetch(`${API}/mouvement/${id}`, { method: 'DELETE', headers: entetes(u) }));

export const creerRepriseCca = (payload, u) => post(`${API}/reprise`, payload, u);
export const validerRepriseCca = (id, u) => post(`${API}/reprise/${id}/valider`, {}, u);
export const corrigerRepriseCca = (id, payload, u) => post(`${API}/reprise/${id}/corriger`, payload, u);

export const majAccesCca = async (emails, u) =>
  json(await fetch(`${API}/acces`, { method: 'PUT', headers: entetes(u), body: JSON.stringify({ emails }) }));

// Clé d'idempotence : protège contre les doubles clics et les nouvelles tentatives.
// La contrepartie retenue en fait partie : changer de choix change la commande.
export const cleIdempotence = (payload) =>
  [
    'cca',
    payload.contact_id,
    payload.nature,
    payload.montant,
    payload.date_effective,
    payload.compte_id,
    payload.reference ?? '',
    payload.tresorerie_existante?.id ?? '',
  ]
    .join('|')
    .toLowerCase();
